import type { FaireProductEntity } from "../../entity_types/product";

export const p_79kamgy8me: FaireProductEntity = {
  token: "p_79kamgy8me",
  type: "product",
  name: "Invecchiato 7-Year Aged Balsamic Vinegar of Modena",
  brandToken: "b_cswuxgoe1w",
  brandName: "Bona Furtuna",
  imageUrl: "https://cdn.faire.com/fastly/a313adc8315724a55c852d816787355e30c971cd2bdb34747cbe6938c9ba9f0b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/51adf6a10d8359d3289c509eb3faa19379b134304238793007d6fc217ac0fa28.jpeg",
    "https://cdn.faire.com/fastly/c7e55a9c7d3c3982c25b0cd28a22ef58e561a1f1494a87847b4deec8507c1773.jpeg",
    "https://cdn.faire.com/fastly/c9d30a9d36ff71798617dc428e4652fcfa092b787f091d1daeb58befda67e9f7.jpeg",
    "https://cdn.faire.com/fastly/02d94c35a27ad5f35ad7ef1a84906de3ad674eda428d1edfd8af09795b67ab96.jpeg",
    "https://cdn.faire.com/fastly/eeced16ad83448ec2d73a309e49808400dcb0d40c734dabedface27d09c33da0.jpeg",
    "https://cdn.faire.com/fastly/fadf5b71bc2d61de8fc0b7a20fc3038199bb9248f8fcbb5e70905e571d61fb9d.jpeg",
    "https://cdn.faire.com/fastly/a30ee80974bca80ceefac36199c588181d7557261295e118d7903d1d1647501d.jpeg"
  ],
  priceDollars: 22.48,
  description: "Resting patiently in select wood barrels for seven years, our 250-ml IGP certified aged balsamic vinegar of Modena brings about unparalleled depth and character. These traditional barrel aging methods allow us to create a rich, lively balsamic vinegar that will give you a new understanding of what cooking with real balsamic vinegar should taste like.\n",
  tags: [],
  msrpDollars: 44.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:23.503Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
